export default "__VITE_ASSET__z6Of8CSE__"